import type { ColorConfig } from './contracts';
import { colorMap } from './support-chat.settings';

const getColorMap = (element: HTMLElement): ColorConfig => {
  return Object.keys(colorMap).reduce((acc, configName) => {
    const themeVar = colorMap[configName] as string;
    const color = window.getComputedStyle(element).getPropertyValue(themeVar);

    acc[configName] = color;

    return acc;
  }, {} as ColorConfig);
};

export { getColorMap };
